export interface SalesOrderDepositDetails {
  id: string;
  salesOrderHeaderId: string;
  amount: number;
  notes: string;
  depositPrintedById: string;
  depositPostedById: string;
  salesInvoiceHeaderId: string;
  depositInvoicePrinted: boolean;
  dateDepositInvoicePrinted: Date;
  depositInvoicePosted: boolean;
  dateDepositInvoicePosted: Date;
  depositInvoicePaid: boolean;
  depositInvoicePaidDate: Date;
  depositInvoicePaidById: string;
}
